import React from 'react';
import Lottie from 'react-lottie';
import './Kyc_lottie_animation.css';
import * as animationData from './Kyc_lottie_animation.json';

function Kyc_lottie_animation(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Kyc_lottie_animation_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Kyc_lottie_animation;